import { Link, useLocation } from 'react-router-dom';
import { GAEvent } from '@/services/ga-tracking';
import { useMemo, useState } from 'react';
import Logo from '@/assets/img/YEGO.svg?react';
import { Hamburger } from '../hamburger';
import { MobileNavbar } from './navbar-mobile';
import { DesktopNavbar } from './navbar-desktop';
import { useUserInfo } from '@/context/user-info';
import { useTranslation } from 'react-i18next';

export const Navbar = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { userLanguage } = useUserInfo();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [servicesMenuOpen, setServicesMenuOpen] = useState<boolean>(false);

  const isDrivingLessonsPage = useMemo(
    () => location.pathname === `/${userLanguage}/driving-lessons`,
    [location.pathname, userLanguage],
  );

  const handleMenuOpen = () => {
    setServicesMenuOpen((prev) => !prev);
  };

  const handleClickHome = () => {
    setIsOpen(false);
    GAEvent('NAVBAR HOME', 'Clicked on home link', 'HOME');
  };

  const handleClickHowItWorks = () => {
    setIsOpen(false);
    GAEvent('NAVBAR HOW IT WORKS', 'Clicked on how it works link', 'HOW_IT_WORKS');
  };
  const handleClickAboutApp = () => {
    setIsOpen(false);
    GAEvent('NAVBAR ABOUT APP', 'Clicked on about app link', 'ABOUT_APP');
  };

  const handleClickDrivingLessons = () => {
    setIsOpen(false);
    GAEvent('NAVBAR DRIVING LESSONS HOMEPAGE', 'Cliked on driving lessons link', 'DRIVING_LESSONS');
  };

  const handleClickBusiness = () => {
    setIsOpen(false);
    GAEvent('NAVBAR BUSINESS HOMEPAGE', 'Cliked on business link', 'HOME_BUSINESS');
  };

  const handleClickGiftCard = () => {
    setIsOpen(false);
    GAEvent('NAVBAR GIFT CARD', 'Cliked on gift card link', 'NAVBAR_GIFT_CARD');
  };

  const handleClickDownload = () => {
    setIsOpen(false);
    GAEvent('DOWNLOAD NAVBAR', 'Cliked on download button', 'NAVBAR_DOWNLOAD');
  };

  return (
    <nav
      className="w-full bg-transparent z-30 max-h-[84px]"
      aria-label={t('translation:accessibility.button.navbar')}
    >
      <div className="w-full relative">
        <div className="w-full flex items-center justify-between py-4 px-4 md:pt-7 md:pb-4">
          <Link
            className="z-50"
            to={`/${userLanguage}`}
            onClick={handleClickHome}
            aria-label={t('translation:accessibility.button.go_home')}
          >
            <Logo className="h-9 w-auto font-phosphate px-2" />
          </Link>

          <Hamburger isOpen={isOpen} onClick={() => setIsOpen((prev) => !prev)} />

          <MobileNavbar
            isOpen={isOpen}
            servicesMenuOpen={servicesMenuOpen}
            isDrivingLessonsPage={isDrivingLessonsPage}
            onMenuOpen={handleMenuOpen}
            onClickHowItWorks={handleClickHowItWorks}
            onClickAboutApp={handleClickAboutApp}
            onClickDrivingLessons={handleClickDrivingLessons}
            onClickBusiness={handleClickBusiness}
            onClickGiftCard={handleClickGiftCard}
            onClickDownload={handleClickDownload}
          />

          <DesktopNavbar
            isDrivingLessonsPage={isDrivingLessonsPage}
            onClickDrivingLessons={handleClickDrivingLessons}
            onClickBusiness={handleClickBusiness}
            onClickGiftCard={handleClickGiftCard}
          />
        </div>
      </div>
    </nav>
  );
};
